import React, { ReactElement, FunctionComponent } from 'react';
import { Route } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

type Props = {
  component: any;
  layout: any;
  middlewares: any;
  // All other props
  [x: string]: any;
};

const LayoutRoute: FunctionComponent<Props> = ({
  component: Component,
  layout: Layout,
  middlewares,
  ...rest
}): ReactElement => (
  <Route
    {...rest}
    render={(props) => (
      <Layout>
        {middlewares?.map((Middleware: React.FC) => <Middleware key={uuidv4()} />)}
        <Component {...props} />
      </Layout>
    )}
  />
);

export default LayoutRoute;
